import { render, staticRenderFns } from "./WidgetSidebar.vue?vue&type=template&id=f5519cfa&scoped=true"
import script from "./WidgetSidebar.vue?vue&type=script&lang=js"
export * from "./WidgetSidebar.vue?vue&type=script&lang=js"
import style0 from "./WidgetSidebar.vue?vue&type=style&index=0&id=f5519cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5519cfa",
  null
  
)

export default component.exports